/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InternetRegistrationReviewResponse,
  ProblemDetails,
} from '../models/index';
import {
    InternetRegistrationReviewResponseFromJSON,
    InternetRegistrationReviewResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DismissInternetRegistrationDuplicateRequest {
    clientId: string;
}

/**
 * InternetRegistrationsApi - interface
 * 
 * @export
 * @interface InternetRegistrationsApiInterface
 */
export interface InternetRegistrationsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternetRegistrationsApiInterface
     */
    dismissInternetRegistrationDuplicateRaw(requestParameters: DismissInternetRegistrationDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    dismissInternetRegistrationDuplicate(requestParameters: DismissInternetRegistrationDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternetRegistrationsApiInterface
     */
    getInternetRegistrationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InternetRegistrationReviewResponse>>>;

    /**
     */
    getInternetRegistrations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InternetRegistrationReviewResponse>>;

}

/**
 * 
 */
export class InternetRegistrationsApi extends runtime.BaseAPI implements InternetRegistrationsApiInterface {

    /**
     */
    async dismissInternetRegistrationDuplicateRaw(requestParameters: DismissInternetRegistrationDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling dismissInternetRegistrationDuplicate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internet-registrations/{clientId}/dismiss-duplicate`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async dismissInternetRegistrationDuplicate(requestParameters: DismissInternetRegistrationDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dismissInternetRegistrationDuplicateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getInternetRegistrationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InternetRegistrationReviewResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internet-registrations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternetRegistrationReviewResponseFromJSON));
    }

    /**
     */
    async getInternetRegistrations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InternetRegistrationReviewResponse>> {
        const response = await this.getInternetRegistrationsRaw(initOverrides);
        return await response.value();
    }

}
